import generateBasicEntityActions from './generateBasicEntityActions';

const internEnterpriseActions = generateBasicEntityActions('internEnterprises', 'internEnterprise');

export default internEnterpriseActions;
